import { createSlice } from '@reduxjs/toolkit';
import {
  getCategoryWithQuestion,
  getQuestion,
  getSubCategoryWithQuestion,
  getSupportCategories,
  searchQuestion
} from '../views/HelpDesk/helpDesk.actions';
import {
  Category,
  CategoryWithQuestions,
  Question
} from '../views/HelpDesk/helpDesk.types';

export interface helpdeskSliceType {
  loading: boolean;
  loadingSearch: boolean;
  categories: Category[];
  category: CategoryWithQuestions | null;
  question: Question | null;
  subCategory: CategoryWithQuestions | null;
  questions: Question[];
}

const initialState = {
  loading: false,
  loadingSearch: false,
  categories: [],
  category: null,
  question: null,
  subCategory: null,
  questions: []
} as helpdeskSliceType;

const helpdeskSlice = createSlice({
  name: 'helpdesk',
  initialState,
  reducers: {
    clearQuestions(state) {
      state.questions = [];
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getSupportCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSupportCategories.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.categories = payload.categories;
      state.category = payload.category;
    });
    builder.addCase(getSupportCategories.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCategoryWithQuestion.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCategoryWithQuestion.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.category = payload;
    });
    builder.addCase(getCategoryWithQuestion.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getSubCategoryWithQuestion.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getSubCategoryWithQuestion.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.subCategory = payload;
      }
    );
    builder.addCase(getSubCategoryWithQuestion.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getQuestion.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getQuestion.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.question = payload;
    });
    builder.addCase(getQuestion.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(searchQuestion.pending, (state) => {
      state.loadingSearch = true;
    });
    builder.addCase(searchQuestion.fulfilled, (state, { payload }) => {
      state.loadingSearch = false;
      state.questions = payload;
    });
    builder.addCase(searchQuestion.rejected, (state) => {
      state.loadingSearch = false;
    });
  }
});

export const { clearQuestions } = helpdeskSlice.actions;

export default helpdeskSlice.reducer;
